import React from 'react';
import PropTypes from 'prop-types';
import { SettingLink } from 'web-ui-components/lib/molecules/panels';
import { Icon } from 'web-ui-components/lib/atoms/iconography';

const AlertTypesCard = ({ typeName, isEnabled, onAlertTypeChange }) => (
  <div className="u-margin-top-1 u-margin-bottom-1 c--setting-link-border">
    <SettingLink
      text={typeName}
      isActive={isEnabled}
      icon={<Icon iconType="AlertOutlineLarge" />}
      onClick={() => {
        onAlertTypeChange(typeName);
      }}
    />
  </div>
);
AlertTypesCard.propTypes = {
  onAlertTypeChange: PropTypes.func,
  typeName: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool,
  selected: PropTypes.bool,
  iconType: PropTypes.string,
};
export default AlertTypesCard;
